import React from "react";
import {
  Nav,
  NavItem,
  Container,
  Row,
  Col,
  Navbar,
} from "reactstrap";
import ElectricMgnt from "./ElecMgnt/ElectricMgnt";


const Individual = (props) => {

  return (
    <>
      <Container fluid className="p-0">
        <Row noGutters>
          <Col>
            <Navbar className="justify-content-center">
              <Nav className="diagram">
                <NavItem className="text-center text_graph">
                  電力管理
                </NavItem>
              </Nav>
            </Navbar>
            <div className="p-1 electricMgmnt">
              <ElectricMgnt />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Individual;
